import { gql } from '@apollo/client';

export default gql`
  mutation cleanupAuthToken {
    cleanupAuthToken(input: {}) {
      success
    }
  }
`;
